import React from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CheckBoxTwoToneIcon from '@material-ui/icons/CheckBoxTwoTone';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import BackButton from '../../components/backButton/backButton';

import './registrationSuccess.less';

const RegistrationSuccess = ({ history }) => (
  <Container className="registration-success-page page-container">
    <BackButton to="/" />
    <div className="title-wrapper">
      <Typography variant="h3">
        Rejestracja
      </Typography>
    </div>

    <Paper className="paper-box">
      <Container>
        <div className="row">
          <div className="icon-wrapper">
            <CheckBoxTwoToneIcon color="primary" />
          </div>
          <div>
            <Typography className="paper-title" variant="h5">
              Dziękujemy za rejestrację w aplikacji!
            </Typography>
            <Typography variant="body1">
              Na adres e-mail, podany w formularzu rejestracyjnym, wysłaliśmy link aktywacyjny.
            </Typography>
          </div>
        </div>
      </Container>
    </Paper>

    <div className="ok-button-container">
      <Button size="large" variant="contained" color="primary" type="submit" onClick={() => history.replace('/')}>
        OK
      </Button>
    </div>
  </Container>
);

RegistrationSuccess.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
};

export default withRouter(RegistrationSuccess);
